import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetContactQuery } from "@/store/rest_api";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import ContactActivity from "@/components/contacts/ContactActivity";
import { PropertyDetailCard } from "@/components/pages/properties/PropertyDetailCard";

const ContactDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: contact } = useGetContactQuery(id!);
  const { setSection, setSectionPath, setPage } = useBreadcrumbs();

  useEffect(() => {
    setSection("Contacts");
    setSectionPath("/contacts");
  }, [setSection, setSectionPath]);

  useEffect(() => {
    if (contact) {
      setPage([contact.firstName, contact.lastName].filter(Boolean).join(" "));
    }
  }, [contact, setPage]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-auto">
        <ContactActivity contactId={id!} showViewButton={false} showManageActions />
        {contact?.properties && contact.properties.length > 0 && (
          <div className="p-4 space-y-4">
            {contact.properties.map((property) => (
              <PropertyDetailCard key={property.id} property={property} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactDetailPage;
